import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider } from '@material-ui/core/styles';
import reviewTheme from 'app/configs/reviewTheme';

import TaskQueue from './taskQueue';

const TaskQueueContainer = () => {
  return (
    <ThemeProvider theme={reviewTheme}>
      <CssBaseline />
      <TaskQueue />
    </ThemeProvider>
  );
};

export default TaskQueueContainer;
